<template>
  <div class="grid gap-3">
    <div v-if="!props.isLiteView" class="text-base font-bold">{{ $t("pages.price_box.volume_pricing") }}</div>
    <div class="overflow-hidden rounded-md border border-[var(--color-neutral-a4)]">
      <VolumePricingTable :product="product" :hide-ladder-discount="hideLadderDiscount" show-discount-column />
    </div>
    <template v-if="!props.isLiteView">
      <div
        class="relative my-2 flex w-full justify-center before:absolute before:left-0 before:top-[45%] before:h-px before:w-full before:bg-[var(--color-neutral-a4)] before:content-['']"
      >
        <div class="flex size-[7px] rotate-45 bg-[var(--color-neutral-a4)] outline outline-4 outline-white"></div>
      </div>
      <div class="grid grid-cols-[auto,max-content] gap-4">
        <div class="grid gap-1.5">
          <div class="font-bold">{{ $t("pages.price_box.interested_in_higher_volumes") }}</div>
          <div class="text-sm leading-[22px]">
            {{
              $t("pages.price_box.interested_in_message", [
                Math.max(...product.price.tierPrices.map((tier) => tier.quantity)),
              ])
            }}
          </div>
          <div class="mt-1">
            <VcButton variant="link" size="lg" class="!font-medium" @click="showPriceDialog(product)">{{
              $t("pages.price_box.contact_us_for_a_quote")
            }}</VcButton>
          </div>
        </div>
        <div class="grid content-start justify-items-center gap-1.5">
          <VcImage
            src="/static/thorlabs/bruno-gross.jpg"
            width="100"
            height="82"
            alt=""
            role="presentation"
            class="mb-1 rounded-md"
          />
          <div class="text-xs font-medium">{{ $t("pages.price_box.vice_president_name") }}</div>
          <div class="text-xs font-medium text-[var(--color-neutral-a2)]">
            {{ $t("pages.price_box.vice_president_title") }}
          </div>
          <div class="text-xs font-medium text-[var(--color-neutral-a2)]">
            {{ $t("pages.price_box.vice_president_global") }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { eventBus } from "@/shared/thorlabs/shared";
import type { Product } from "@/core/api/graphql/types";
import VolumePricingTable from "@/shared/thorlabs/shared/components/volume-pricing-table.vue";

export interface IProps {
  product: Product;
  isLiteView?: boolean | undefined;
  hideLadderDiscount?: boolean | undefined;
}

const props = defineProps<IProps>();

const showPriceDialog = (product: Product) => {
  eventBus.emit("showPriceRequestDialog", { product });
};
</script>
